<template>
  <transition appear name="component-fade">
    <div class="spnod-admin__form--container container pl-0 mx-0 mb-4">
      <p v-if="isDisclaimerDisplayed" class="small mb-4 text-primary">Thank you for adding this user. Do you want to add additional parents or guardians to this account?</p>
      <b-form @submit.stop.prevent="$emit('submitEvent')">
        <b-form-row class="mb-2">
          <b-col>
            <b-form-input
              name="firstName"
              :value="$v.value.firstName.$model"
              @input="handleInput('firstName', $event)"
              :state="validateState('firstName')"
              type="text"
              placeholder="First Name"
              size="sm"
            ></b-form-input>
          </b-col>
          <b-col>
            <b-form-input
              name="lastName"
              :value="value.lastName"
              @input="handleInput('lastName', $event)"
              :state="validateState('lastName')"
              type="text"
              placeholder="Last Name"
              size="sm"
            ></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-input
          :value="value.email"
          @input="handleInput('email', $event)"
          :state="validateState('email')"
          type="email"
          placeholder="Email"
          size="sm"
          class="mb-2"
        ></b-form-input>
        <b-form-group class="mb-0">
          <b-form-input
            :value="value.phone"
            @input="handleInput('phone', $event)"
            :state="validateState('phone')"
            type="tel"
            placeholder="Phone Number"
            size="sm"
            class="mb-2"
          ></b-form-input>
          <b-form-invalid-feedback class="mb-2">
            Must follow this format: 8885551234
          </b-form-invalid-feedback>
        </b-form-group>
        <b-row class="d-flex justify-content-between mx-0">
          <b-button
            v-if="isFirst"
            class="spnod-admin__form--button"
            type="button"
            size="sm"
            @click="$router.go(-1)">
            Back
          </b-button>
          <b-button
            v-if="!isFirst"
            class="bg-danger"
            type="button"
            size="sm"
            @click="$emit('updateEvent', 'remove', $vnode.key)">
            Remove
          </b-button>
          <b-form-group v-if="isLast" class="d-flex flex-grow justify-content-end mb-0">
            <router-link v-if="forClient" to="/user/payment">
              <b-button class="spnod-admin__form--button" type="button" size="sm">Skip</b-button>
            </router-link>
            <b-button
              class="spnod-admin__form--button"
              type="button" size="sm"
              :disabled="isDisabled"
              @click="$emit('updateEvent', 'add')">
              Add
            </b-button>
            <b-button
              class="spnod-admin__form--button"
              type="submit" size="sm"
              :disabled="disableSubmit">
              <p v-if="!isSending">Submit</p>
              <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </b-button>
          </b-form-group>
        </b-row>
      </b-form>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email, alpha, numeric } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
  name: 'ParentForm',
  props: ['value', 'count', 'disableSubmit', 'isSending', 'forClient'],
  mixin: [validationMixin],
  computed: {
    ...mapGetters(['isParent']),
    isDisabled() {
      return this.$v.value.$anyError
    },
    isDisclaimerDisplayed() {
      return this.isFirst && this.isParent
    },
    isFirst() {
      return this.$vnode.key === 0
    },
    isLast() {
      return this.$vnode.key === this.count
    }
  },
  methods: {
    handleInput(name, value) {
      this.$emit('inputEvent', name, value, this.$vnode.key)
      this.value.errors = this.$v.value.$anyError
    },
    validateState(name) {
      this.$v.value[name].$touch()
      const { $dirty, $error } = this.$v.value[name]
      return ($dirty && this.$v.value[name].$model !== '') ? !$error : null
    }
  },
  validations: {
    value: {
      firstName: { required, alpha },
      lastName: { required, alpha },
      email: { required, email },
      phone: { required, numeric, isTenDigits: (number) => number.length === 10 },
      errors: {}
    }
  }
}
</script>

<style scoped>
.flex-grow {
    flex: 1 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/app/components/Forms/ParentForm.vue?4c4a5372